<template>
  <div>
    <a href="/Sample-Data-Logs.xlsx">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            small
            v-bind="attrs"
            v-on="on"
          >
            <!-- @click="downloadStaticSample" -->
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>
          Download Sample XLSX File.
          <br>
          Data Should be in same format
        </span>
      </v-tooltip>
    </a>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";

// import sampleFile from "@/assets/dummy/Sample-Data-Logs.xlsx";

export default {
  computed: {
    ...mapGetters({
      terminalList: "terminal/getList",
      dispenserList: "fuelDispenser/getList",
    }),
  },
  methods: {
    // downloadStaticSample() {
    //   const link = document.createElement("a");
    //   link.href = require("/Sample-Data-Logs.xlsx"); // Resolves to /dummy/Sample-Data-Logs.xlsx
    //   link.download = "Sample-Data-Logs.xlsx";
    //   link.style.display = "none";
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },
    downloadSampleExcel() {
      const terminal = this.terminalList.map((r) => ({
        ID: r.id,
        Name: r.name,
      }));

      const dispenser = this.dispenserList.map((r) => ({
        ID: r.id,
        Name: r.dispenser_identifier,
        Terminal: r.terminal_id,
      }));

      const nozzlesArr = [];
      this.dispenserList.forEach((d) => {
        if (d.nozzles && d.nozzles.length) {
          d.nozzles.forEach((n) => {
            nozzlesArr.push({
              ID: n.id,
              Name: n.nozzle_number,
              Dispenser: n.dispenser,
            });
          });
        }
      });

      const voidSheet = {};

      // Note in A1
      voidSheet["A1"] = {
        t: "s",
        v: "Note: You cannot edit or delete the 'void' sheet, and you are not allowed to rename the 'Data-logs' sheet. Please enter data using the same formatting.",
        s: { protection: { locked: true } },
      };

      // Terminal Title
      voidSheet["A3"] = {
        t: "s",
        v: "Terminal Table",
        s: { protection: { locked: true } },
      };
      XLSX.utils.sheet_add_json(voidSheet, terminal, {
        origin: "A4",
        skipHeader: false,
      });

      // Dispenser Title
      voidSheet["D3"] = {
        t: "s",
        v: "Dispenser Table",
        s: { protection: { locked: true } },
      };
      XLSX.utils.sheet_add_json(voidSheet, dispenser, {
        origin: "D4",
        skipHeader: false,
      });

      // Nozzle Title
      voidSheet["G3"] = {
        t: "s",
        v: "Nozzle Table",
        s: { protection: { locked: true } },
      };
      XLSX.utils.sheet_add_json(voidSheet, nozzlesArr, {
        origin: "G4",
        skipHeader: false,
      });

      // Protect the void sheet
      voidSheet["!protect"] = {
        password: "ORKO@123", // Set if needed
        selectLockedCells: true,
        selectUnlockedCells: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        sort: false,
        autoFilter: false,
        pivotTables: false,
      };

      // Create Data-logs sheet
      const dataLogsHeaders = [
        {
          date: "aaa",
          bus_no: "111",
          filling_time: "111",
          reg_no: "222",
          terminal: "asd",
          dispenser: "6",
          nozzle: "1",
          total_diesel: "550",
        },
      ];

      const dataLogsSheet = XLSX.utils.json_to_sheet(dataLogsHeaders, {
        skipHeader: false,
        header: [
          "date",
          "bus_no",
          "filling_time",
          "reg_no",
          "terminal",
          "dispenser",
          "nozzle",
          "total_diesel",
        ],
      });

      // Create and export workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, dataLogsSheet, "Data-logs");
      XLSX.utils.book_append_sheet(workbook, voidSheet, "void");

      XLSX.writeFile(workbook, "Sample-Data-Logs.xlsx");
    },
  },
};
</script>
